<app-dialog
        [dialogWithInput]="dialog">
    <app-create-update-default
            (entityLoaded)="entityLoaded($event)"
            [findOneService]="findOneService"
            [formGroup]="formGroup"
            [id]="dialog.input.id"
            [service]="service"
            [buildPayload]="buildPayload"
            [inDialog]="true"
            (entitySaved)="entitySaved($event)"
            [hideSaveButton]="true"
            #createUpdateDefaultComponent>
        <ng-template template-content>
            <app-card-v2 [hideHeader]="true">
                <app-loading [loading]="loadingFormModel$ | async"></app-loading>
                <app-form-form-save  #formFormSaveComponent *ngIf="examForm?.form"
                                     [previousComment]="this.dialog.input.previousExam?.summary?.form?.comment"
                                     [formModel]="examForm.form"
                                     displayType="table"
                                     groupDisplay="asTitle"
                                     [allCardsExpanded]="allCardsExpanded"
                                     [partner]="partner"
                                     [parentFormGroup]="formGroup">

                    <app-form-field additional-fields label="Set de soin" *ngIf="!dialog.input.id">
                        <app-medical-toolset-select-many [parentFormGroup]="formGroup" parentFormControlName="medicalInstrumentSetIds" [parameters]="medicalInstrumentSetParameters"></app-medical-toolset-select-many>
                    </app-form-field>

                </app-form-form-save>
            </app-card-v2>
        </ng-template>
    </app-create-update-default>
    <ng-container dialog-actions>
        <app-loading [loading]="createUpdateDefaultComponent.saveLoading" [showText]="false"></app-loading>
        <div class="link" style="display: flex; align-items: center;" *ngIf="formGroup.valid && !createUpdateDefaultComponent.saveLoading &&
                !createUpdateDefaultComponent.loading && !createUpdateDefaultComponent.findOneError" (click)="executeSave(false)">Enregistrer et rester</div>
        <app-button (click)="executeSave(true)" [disabled]="!formGroup.valid" fill="solid" size="small"
                    iconName="check" label="Enregistrer" *ngIf="!createUpdateDefaultComponent.saveLoading &&
                !createUpdateDefaultComponent.loading && !createUpdateDefaultComponent.findOneError"></app-button>
    </ng-container>
</app-dialog>

